import { useInfiniteQuery, useMutation } from 'react-query';
import { InstallmentTagsQueryFilter } from './InstallmentTags.type';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import service from './InstallmentTags.service';
import { queryClient } from '@/Root';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';

const INSTALLMENT_TAGS_LIST = 'installment-tags/list';

export function useInstallmentTagsList(
  params?: InstallmentTagsQueryFilter,
  enabled = true,
) {
  const cache = queryClient.getQueryData([
    INSTALLMENT_TAGS_LIST,
    { ...params },
  ]);

  return useInfiniteQuery(
    [INSTALLMENT_TAGS_LIST, { ...params }],
    ({ pageParam }) => {
      const req: InstallmentTagsQueryFilter = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return service.list(req);
    },
    {
      enabled: !cache && enabled,
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useInstallmentTagsCreate() {
  const queryChanel = useQueryChanel();

  return useMutation(service.create, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Etiqueta criada com sucesso',
      });

      queryChanel({ removeQueries: [[INSTALLMENT_TAGS_LIST]] });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useInstallmentTagsUpdate() {
  const queryChanel = useQueryChanel();

  return useMutation(service.update, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Etiqueta editada com sucesso',
      });

      queryChanel({ removeQueries: [[INSTALLMENT_TAGS_LIST]] });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useInstallmentTagsDelete() {
  const queryChanel = useQueryChanel();

  return useMutation(service.remove, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Etiqueta excluída com sucesso',
      });

      queryChanel({ removeQueries: [[INSTALLMENT_TAGS_LIST]] });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
